import Button from '../../../Button'
import { PdfPreview } from '../../../FilesPreviewGallery'
import { PdfViewerNavigation } from '../../../PdfViewer'
import { Skeleton } from '../../../Skeleton'
import { isDocFlowActiveWidgetResult } from '../../DocFlow.utils.widgets'
import { DocFlowPdfSelectArea } from '../../DocFlowPdfSelectArea'
import { DOC_FLOW_MAPPING_PDF_VIEWER_TOOLS } from '../DocFlowMapping.constants'
import { DocFlowMappingResultTable } from '../DocFlowMappingResultTable'

import * as styles from '../DocFlowMapping.module.css'

function DocFlowMappingPreviewContent({
  activeFileForPreview,
  activeWidget,
  processData,
  viewerProps,
}) {
  return !activeWidget || !processData ? (
    <Skeleton className={styles.skeleton} />
  ) : isDocFlowActiveWidgetResult(activeWidget) ? (
    <DocFlowMappingResultTable />
  ) : (
    <PdfPreview
      isSkeleton
      className={styles.pdfPreview}
      file={activeFileForPreview}
      pdfViewerProps={{
        ...viewerProps,
        Navigation: PdfViewerNavigation,
        SelectAreaBox: DocFlowPdfSelectArea,
        className: styles.pdfViewer,
        navigationProps: {
          arrowButtonProps: { Component: Button.Contained, isLight: true },
          buttonClassName: styles.navButton,
          leftButtonClassName: styles.navButtonLeft,
          rightButtonClassName: styles.navButtonRight,
        },
        singlePage: true,
        tools: DOC_FLOW_MAPPING_PDF_VIEWER_TOOLS,
      }}
    />
  )
}

export default DocFlowMappingPreviewContent
